import { render, staticRenderFns } from "./custom-links.vue?vue&type=template&id=4f6806d0&"
import script from "./custom-links.vue?vue&type=script&lang=js&"
export * from "./custom-links.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports